import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { AlertCircleIcon } from '../../components/ui/icons';
import './feedModal.css';

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  /** Thumbnail of the subject of the confirmation, e.g. the post being deleted. */
  mediaUrl?: string | null;
  /** Portraits should use contain; post thumbnails keep the default cover crop. */
  mediaFit?: 'cover' | 'contain';
  loading?: boolean;
  showIcon?: boolean;
}

export function getConfirmMediaClassName(
  mediaFit: 'cover' | 'contain',
): string {
  return `feed-prompt__media feed-prompt__media--preview${
    mediaFit === 'contain' ? ' feed-prompt__media--contain' : ''
  }`;
}

export function ConfirmModal({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onClose,
  onConfirm,
  mediaUrl = null,
  mediaFit = 'cover',
  loading = false,
  showIcon = false,
}: ConfirmModalProps) {
  return (
    <Modal
      title={title}
      onClose={loading ? () => undefined : onClose}
      labelledBy="confirm-modal-title"
      className="feed-prompt-modal"
    >
      <div className="feed-prompt">
        {mediaUrl ? (
          <img
            className={getConfirmMediaClassName(mediaFit)}
            src={mediaUrl}
            alt=""
          />
        ) : showIcon ? (
          <span className="feed-prompt__media feed-prompt__media--alert" aria-hidden>
            <AlertCircleIcon size={48} />
          </span>
        ) : null}
        <div className="feed-prompt__copy">
          {/* The dialog is already named by the header heading Modal renders. */}
          <p className="feed-prompt__title" aria-hidden="true">{title}</p>
          <p className="feed-prompt__message">{message}</p>
        </div>
        <div className="feed-prompt__actions">
          <Button variant="ghost" size="md" fullWidth onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button size="md" fullWidth onClick={onConfirm} disabled={loading}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
